import { jsx as _jsx } from "react/jsx-runtime";
import RightArrow from "static/svg/arrow-right-3.svg";
import classnames from "classnames";
import { MD } from "constants/sizes";
import { StyledArrowButton } from "./button-arrow.scss";
const ButtonArrow = (props)=>{
    const { size, hover, isSignup } = props;
    return /*#__PURE__*/ _jsx(StyledArrowButton, {
        className: classnames("arrow-wrapper", size, {
            hover: hover,
            signup: isSignup
        }),
        children: /*#__PURE__*/ _jsx(RightArrow, {
            "aria-hidden": "true",
            focusable: "false"
        })
    });
};
ButtonArrow.defaultProps = {
    size: MD
};
export default ButtonArrow;
